/* ------------------------------------------------------------------
   Waitlist pop-up — seamless (no-reload) newsletter submit.

   The form is a recognised {% form 'customer' %} (correct action +
   form_type/utf8). We never fire a native submit event (button is
   type=button, Enter is intercepted), so nothing reloads. We POST it via
   fetch (no iframe — the storefront sets frame-ancestors 'none').

   Spam protection is OFF for contact/customer forms (Online Store →
   Preferences → Spam protection), so no CAPTCHA token is required — we POST
   plainly. We must NOT call Shopify.captcha.protect() here: it loads site-wide
   (the account pages ARE protected) and would force a captcha onto this
   unprotected form, injecting a failing h-captcha-response → 400.

   NOTE: form POSTs do NOT work on the `shopify theme dev` localhost server
   (it 403s every POST). Test on the real preview URL.
------------------------------------------------------------------ */
(function () {
  if (window.tamreWaitlist) return;

  window.tamreWaitlist = {
    // Resolves true only when the submission actually succeeded.
    submit: function (form) {
      return new Promise(function (resolve) {
        var sent = false;
        var send = function () {
          if (sent) return;
          sent = true;
          var params = new URLSearchParams(new FormData(form));
          // TEMP diagnostic — remove once confirmed on the preview URL.
          console.log('[waitlist] posting fields:', Array.from(params.keys()).join(', '));
          fetch(form.action, {
            method: 'POST',
            body: params,
            redirect: 'follow',
            headers: {
              Accept: 'text/html, application/xhtml+xml, */*; q=0.01',
              'X-Requested-With': 'XMLHttpRequest'
            }
          })
            .then(function (res) {
              console.log('[waitlist] submit →', res.status, res.url); // TEMP
              resolve(!!(res && res.ok && res.url.indexOf('/challenge') === -1));
            })
            .catch(function () {
              resolve(false);
            });
        };

        // Plain POST, no CAPTCHA token — see the header note (protect() would force a
        // captcha onto this unprotected form and 400).
        send();
      });
    }
  };
})();
